import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    readMore: {
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
  comments: {
    display: "flex",
    wordWrap: "break-word",
    alignItems: "center",
  },
  slaComment: {
    backgroundColor: "#DBEAFE",
    color: "#1D4ED8",
    borderRadius: "5px",
    padding: "2px 5px",
    fontSize: "15px",
    fontFamily: "monospace",
  },
  slaPriceReview: {
    backgroundColor: "#e6e1f3",
    color: "#7700c1e0",
    borderRadius: "5px",
    padding: "2px 5px",
    fontSize: "15px",
    fontFamily: "monospace",
  },
  newcommentCard: {
    padding: "5px 50px",
    border: "1px solid #e0e0e0",
  },
  commentHistoryCard: {
    padding: "5px 50px",
    border: "1px solid #e0e0e0",
  }
}));